import React from 'react';

import { InterstitialFlowProps } from '../../types';

import { VideoWalkthroughModal } from './VideoWalkthroughModal';

export const VideoWalkthroughFlow: React.FC<
  InterstitialFlowProps & {
    onComplete: () => Promise<void>;
  }
> = ({ onComplete }) => {
  const handleModalClose = async () => {
    await onComplete();
  };

  return <VideoWalkthroughModal isOpen={true} onClose={handleModalClose} />;
};
